import * as React from "react";
import { ui } from "../../../../dependencies";
export class SecondaryHeadingWrap extends React.PureComponent {
    renderSubheading() {
        return React.createElement(ui.SubHeading, null,
            React.createElement("div", { className: `rj-sub-heading-inner rj-sub-heading-inner--${this.props.cardType.toLowerCase()}` },
                React.createElement(ui.HeadingTitle, { name: this.props.name, count: this.props.eventsCount })));
    }
    render() {
        return (React.createElement(ui.InstantCollapsible, { initiallyExpanded: this.props.shouldExpand, trigger: this.renderSubheading(), content: React.createElement(React.Fragment, null, this.props.children) }));
    }
}
//# sourceMappingURL=SecondaryHeadingWrap.js.map